type Decimal = 10 | 100 | 1000 | 10000;

const roundNumber = (number: number, decimal = 100 as Decimal): number => {
  let k = 1000000;
  while (k / decimal !== 1) {
    number = Math.round((number + Number.EPSILON) * k) / k;
    k /= 10;
  }

  return Math.round((number + Number.EPSILON) * decimal) / decimal;
};

export default roundNumber;
